import React from 'react';
import SlidingSideBar from '../SlidingSideBar/SlidingSideBar';
import PrintGroupsV2 from '../doc-hub-v2/PrintGroupsV2';

const DochubSidebar = ({ show, onHide, source, contractId, contactId, appChoices, onUpdateDocHub, document = 'Commission Sheet', title
}) => {
  return (
    <SlidingSideBar fullScreen visible={show} onClose={onHide} title={title || `Print ${document}`}>
      {show && (
        <PrintGroupsV2
          key={document}
          appChoices={appChoices}
          source={source}
          contractId={contractId}
          contactId={contactId}
          sidebarMode={true}
          document={document}
          onUpdateDocHub={onUpdateDocHub}
        />
      )}
    </SlidingSideBar>
  );
};

export default DochubSidebar;
